export default function Divider() {
    return <hr className="h-px my-4 w-full bg-darkSurface border-0" />;
}
